module.exports = "/packs/media/images/icons/SavingsSteps_1-8202ab07858e3d32665f70af632c5ddb.png";